export default __webpack_public_path__ + "static/media/cashTxn.67705af9.svg";